import React from "react";
import { baseUrl, translate } from "@kaltura/mediaspace-shared-utils";
import { MailIllustration, StatusScreen } from "@kaltura/mediaspace-shared-ui";
import { useScript } from "@kaltura/mediaspace-shared-hooks";
import { RegistrationType } from "./SiteRegistrationProps";

export interface Props {
    registrationType: RegistrationType;
    completeTitle: string;
    completeDescriptionHtml: string;
    completeButtonText?: string;
    completeButtonUrl?: string;
    onCompleteScriptContent?: string;
}

/**
 * Site registration complete/updated screen
 */
const RegistrationComplete: React.FC<Props> = ({
    registrationType = RegistrationType.NEW,
    completeTitle,
    completeDescriptionHtml,
    completeButtonText,
    completeButtonUrl,
    onCompleteScriptContent,
}) => {
    useScript(onCompleteScriptContent);
    return (
        <>
            {registrationType !== RegistrationType.EDIT && (
                <StatusScreen
                    className={"kms-ds-site-registration-complete"}
                    contentWidth={584}
                    title={completeTitle}
                    text={completeDescriptionHtml}
                    buttonLabel={completeButtonText}
                    buttonProps={{
                        href: completeButtonUrl,
                        rel: "noreferrer",
                    }}
                    image={MailIllustration}
                    adjustVerticalPadding={true}
                />
            )}
            {registrationType === RegistrationType.EDIT && (
                <StatusScreen
                    className={"kms-ds-site-registration-complete"}
                    contentWidth={584}
                    title={translate("Details updated successfully")}
                    text={translate("Your details have been successfully updated")}
                    buttonLabel={translate("Go To Profile")}
                    buttonProps={{
                        href: `${baseUrl}/profile`,
                    }}
                    adjustVerticalPadding={true}
                />
            )}
        </>
    );
};

export default RegistrationComplete;
